// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__dUQ_E","filters":"styles_filters__p_C7f","image":"styles_image__aDnXK"};